




































































































































































const namespace = 'workshopsSchedule';
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import RestResource from '@/modules/api/RestResource';
import ICalendarData from '@/modules/calendar/interfaces/ICalendarData';
import IPaymentRequest from '@/modules/form/interfaces/IPaymentRequest';
import LocaleSwitcher from '@/components/LocaleSwitcher.vue';
import Schedule from '@/modules/workshops-schedule/components/Schedule.vue';
import { WeekDay, WeekSchedule, Workshop, Timeline } from '@/modules/workshops-schedule/models/weekScheduleModels';
import { Registration } from '@/modules/workshops-schedule/models/formModels';
import { FormHelper } from '@/modules/workshops-schedule/models/logic/FormHelper';
import { generateClientIP } from '@/utils/web';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { EventTicket, AvailableTicketType } from '../models/EventRegistration';

@Component({
    name: 'EventTicketChange',
    components: {
        ValidationProvider,
        ValidationObserver,
        LocaleSwitcher,
        Schedule,
    },
})
export default class EventTicketChange extends Vue {
    @Getter('loading', { namespace }) private loading!: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('setLoading', { namespace }) private setLoading: any;
    @Getter('isGuidelineVisible', { namespace: 'workshopsSchedule' }) private isGuidelineVisible!: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('showGuideline', { namespace }) private showGuideline: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('hideGuideline', { namespace }) private hideGuideline: any;
    @Getter('currentEventId', { namespace: 'form' }) private currentEventId!: number;
    @Getter('weekSchedule', { namespace }) private weekSchedule!: WeekSchedule;
    @Getter('weekDays', { namespace }) private weekDays!: WeekDay[];
    @Getter('workshops', { namespace }) private workshops!: Workshop[];
    @Getter('timeline', { namespace }) private timeline!: Timeline[];
    @Getter('apiUrl', { namespace: 'configuration' }) private apiUrl!: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('setEvents', { namespace: 'calendar' }) private setEvents: any;
    @Getter('getAllEvents', { namespace: 'calendar' }) private getAllEvents!: ICalendarData[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('setWeekSchedule', { namespace }) private setWeekSchedule: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('fetchAvaiableTicketTypes', { namespace }) private fetchAvaiableTicketTypes: any;
    @Action('fetchCurrentWeekDays', { namespace }) private fetchCurrentWeekDays: any;
    @Action('setFormDetails', { namespace }) private setFormDetails: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('loadFormStateForRegistration', { namespace }) private loadFormStateForRegistration!: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('loadParticipantEventTickets', { namespace }) private loadParticipantEventTickets!: any;
    @Getter('availableTicketsTypes', { namespace }) private availableTicketsTypes!: AvailableTicketType[];
    @Getter('availableTicketsIds', { namespace }) private availableTicketsIds!: number[];
    @Getter('selectedWorkshopsIds', { namespace }) private selectedWorkshopsIds!: number[];
    @Getter('selectedTicketsIds', { namespace }) private selectedTicketsIds!: number[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('tooglSelectedWorkshopId', { namespace }) private tooglSelectedWorkshopId: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('toogleSelectedTicket', { namespace }) private toogleSelectedTicket: any;
    private get cssVariables() {
        return (
            '--weekday-width:' +
            100 / this.weekSchedule.WeekDays.length +
            '%; ' +
            '--location-width:' +
            100 / this.weekSchedule.WeekDays[0].Locations.length +
            '%; ' +
            '--room-width:' +
            100 / this.weekSchedule.WeekDays[0].Locations[0].Rooms.length +
            '%; ' +
            '--schedule-board-container-height: 1000px;'
        );
    }

    private getTranslation(key: string) {
        return this.$t(key).toString();
    }

    //#region form
    private eventId = 0;
    private formStep = 1;
    private alertsVisible = false;
    private selectedEventTicket: EventTicket | null = null;
    private newSelectedTicketId: number | null = null;
    private errors: any[] = [];
    private alerts: object[] = [];
    private participantEventTickets: EventTicket[] = [];
    private formHelper = new FormHelper();
    private sexItems = [
        { value: 1, text: this.getTranslation('userForm.male') },
        { value: 2, text: this.getTranslation('userForm.female') },
    ];

    public async mounted() {
        const eventId =
            this.$route.query.e ||
            this.$route.query.eventId ||
            this.$route.query.EventId ||
            this.currentEventId.toString();
        if (eventId !== undefined) {
            this.eventId = +eventId as number;
        }

        generateClientIP();

        this.eventTicketsExchangesResource.$on('resourceCreated', this.onEventTicketExchangeCreated);
        this.eventTicketsExchangesResource.baseUrl = this.apiUrl + '/eventTickets/Exchanges';

        if (this.isSessionContinuation) {
            const eventRegistrationId = +this.$route.query.i as number;
            const eventRegistrationGuid = this.$route.query.g as string;

            this.setFormDetails({
                eventRegistrationId: eventRegistrationId,
                eventRegistrationGuid: eventRegistrationGuid,
            });

            const form = await this.loadFormStateForRegistration();
            this.form = form as Registration;

            this.participantEventTickets = await this.loadParticipantEventTickets();
        }
    }

    private get isSessionContinuation() {
        return this.$route.query.g !== undefined && this.$route.query.i !== undefined;
    }

    private cleanUrlParameters() {
        window.history.replaceState(null, '', '/');
    }

    private readonly SubmitEventTicketChange = this.apiUrl + '/registrations/EventTickets/Exchanges';
    private eventTicketsExchangesResource: RestResource<EventTicket> = new RestResource<EventTicket>(
        this.SubmitEventTicketChange,
        this.onResourceLoading,
        this.onResourceLoadingFinished,
        this.onError,
    );
    private readonly PaymentRequests = this.apiUrl + '/payments/PaymentRequests';
    private paymentsResource: RestResource<IPaymentRequest> = new RestResource<IPaymentRequest>(
        this.PaymentRequests,
        this.onResourceLoading,
        this.onResourceLoadingFinished,
        this.onError,
    );

    private form: Registration = this.formHelper.createEmptyRegistrationForm(this.eventId);

    private get ticketsSelected(): boolean {
        return this.selectedWorkshopsIds.length < 1;
    }

    private get eventParticipantSexTypeId(): number | null {
        return this.form.ParticipantData.SexTypeId.Value;
    }

    private get ticketsToChange() {
        return this.participantEventTickets.map(x => ({ value: x.ticketTypeId, text: x.name }));
    }

    private get tickets() {
        let sexTypeId = this.form.ParticipantData.SexTypeId.Value;
        if (!sexTypeId) {
            sexTypeId = 1;
        }
        const ticketTypes = this.availableTicketsTypes.filter(x => x.sexTypeId === sexTypeId && x.isAvailable);
        return ticketTypes;
    }

    private getTicketsToSelect(tickets: AvailableTicketType[]) {
        if (!tickets) {
            return [];
        }

        return tickets.filter(x => !x.name.includes('Lunch')).map(x => ({ value: x.id, text: x.name }));
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private onError(data: any) {
        console.error(data);
        this.errored = true;
        if (data.error !== undefined) {
            this.showError(data.error.message);
        } else {
            this.showError(this.getTranslation('messages.We cant submit your form'));
        }
    }

    private showError(message: string) {
        this.alerts.push({ type: 'error', message: message });
        this.alertsVisible = true;
    }

    private showWarning(message: string) {
        this.alerts.push({ type: 'warning', message: message });
        this.alertsVisible = true;
    }

    private showInfo(message: string) {
        this.alerts.push({ type: 'info', message: message });
        this.alertsVisible = true;
    }

    private showSuccess(message: string) {
        this.alerts.push({ type: 'success', message: message });
        this.alertsVisible = true;
    }

    private closeAlerts() {
        this.alertsVisible = false;
        this.alerts = [];
    }

    private async submitEventTicketExchange(eventTicket: EventTicket) {
        this.selectedEventTicket = eventTicket;
        this.newSelectedTicketId = eventTicket.newSelectedTicketId;
        const observers = this.$refs[`observer${this.selectedEventTicket?.id}`] as Vue[] | Element[];
        if (observers.length > 0) {
            const observer = observers[0] as any;
            const result = await observer.validate();
            if (!result) {
                return;
            }
        }
    }

    private async submit() {
        const observers = this.$refs[`observer${this.selectedEventTicket?.id}`] as Vue[] | Element[];
        if (observers.length > 0) {
            const observer = observers[0] as any;
            const result = await observer.validate();
            if (!result) {
                return;
            }
        }
        this.eventTicketsExchangesResource.baseUrl =
            this.apiUrl +
            `/registrations/EventTickets/Exchanges/${this.selectedEventTicket?.guid}/${this.selectedEventTicket?.newSelectedTicketId}`;
        await this.eventTicketsExchangesResource.createNewResource();
    }

    private async onEventTicketExchangeCreated(response: any) {
        if (response) {
            // this.cleanUrlParameters();
            // this.participantEventTickets = response;
            this.participantEventTickets = await this.loadParticipantEventTickets();
            this.showInfo(this.getTranslation('changeTicketForm.messages.ticketExchanged'));
            // this.clear();

            this.newSelectedTicketId = null;
            this.selectedEventTicket = null;

            return;
        } else {
            this.showError(this.getTranslation('changeTicketForm.messages.errorDuringTicketExchange'));
        }
    }

    private get clientIp() {
        let clientIp = localStorage.getItem('clientIp');
        if (clientIp === undefined || clientIp === null || clientIp === '' || clientIp === 'undefined') {
            clientIp = '127.0.0.1'; // fake IP in case of issuses with getting parameter that is required for the payent
        }

        return clientIp;
    }

    private clear() {
        this.newSelectedTicketId = null;
        this.selectedEventTicket = null;

        this.formHelper.clearRegistrationForm(this.form);

        this.clearSelectedTickets();

        (this.$refs.observer as any).reset();
        this.formStep = 1;
    }

    private clearSelectedTickets() {
        this.selectedTicketsIds?.forEach(ticketId => {
            this.toogleSelectedTicket(ticketId);
            this.selectedTicketsIds.splice(this.selectedTicketsIds.indexOf(ticketId), 1);
        });
        this.form.ParticipantData.SelectedTickets.Value = [];
    }

    //#endregion form

    private errorMessage = '';
    private errored = false;

    private onResourceLoading() {
        this.setLoading(true);
    }

    private onResourceLoadingFinished() {
        this.setLoading(false);
    }

    private getTicketImage(ticketId: number) {
        switch (ticketId) {
            case 23:
                return this.getImageUrl('/images/instruktorzy/Thumbnail_ZWF_Michael_Aline.jpg');
            case 24:
            case 32:
                return this.getImageUrl('/images/instruktorzy/Thumbnail_ZWF_Anderson_Brenda.jpg');
            case 25:
            case 33:
                return this.getImageUrl('/images/instruktorzy/Thumbnail_ZWF_Leo_Ana.jpg');
            case 26:
                return this.getImageUrl('/images/instruktorzy/Thumbnail_ZWF_Master_Path.jpg');
            case 27:
                return this.getImageUrl('/images/instruktorzy/Thumbnail_ZWF_Piotr_Patrycja.jpg');
            case 28:
                return this.getImageUrl('/images/instruktorzy/Thumbnail_ZWF_Party.jpg');
            case 29:
                return this.getImageUrl('/images/instruktorzy/Thumbnail_ZWF_Lunch_Friday.jpg');
            case 30:
                return this.getImageUrl('/images/instruktorzy/Thumbnail_ZWF_Lunch_Saturday.jpg');
            case 31:
                return this.getImageUrl('/images/instruktorzy/Thumbnail_ZWF_Lunch_Sunday.jpg');
        }
    }

    private getImageUrl(url: string) {
        if (url === undefined) {
            return '';
        }
        const pluginDirectory = process.env.VUE_APP_IMAGES_DIR;
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const imgUrl = require(`@/assets${url}`);
        return this.isWordPressPlugin && !imgUrl.startsWith('data:image/jpeg;base64')
            ? pluginDirectory + imgUrl
            : imgUrl;
    }

    protected get isWordPressPlugin() {
        return process.env.VUE_APP_IS_WORDPRESS_PLUGIN === 'true';
    }
}
